module.exports = __webpack_public_path__ + "static/media/village_page11.8d3e0574.png";